module.exports = __webpack_public_path__ + "fonts/655291e7fca62a0ad01acbbbf4d25a9c.svg";